/**
 * Formata um número para exibição no input monetário (sem símbolo de moeda).
 * Ex: 1234.5 → "1.234,50"
 */
export const applyMoneyMask = value => {
  if (value == null) return "0,00";
  return Number(value).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

/**
 * Converte o valor digitado no input monetário de volta para float.
 * Suporta separador de milhar (.) e decimal (,).
 * Ex: "1.234,50" → 1234.5
 */
export const cleanMoneyMask = str => {
  const cleaned = String(str).replace(/\./g, "").replace(",", ".");
  const parsed = parseFloat(cleaned);
  return isNaN(parsed) ? null : parsed;
};

export const decimalMask = value => {
  if (!value) return "";

  // Remove tudo que não é dígito ou vírgula
  let cleanValue = value.toString().replace(/[^\d,]/g, "");

  // Permite apenas uma vírgula (mantém a primeira, remove as demais)
  const firstCommaIndex = cleanValue.indexOf(",");
  if (firstCommaIndex !== -1) {
    cleanValue =
      cleanValue.substring(0, firstCommaIndex + 1) +
      cleanValue.substring(firstCommaIndex + 1).replace(/,/g, "");
  }

  return cleanValue;
};

export const convertToFloat = value => {
  if (!value || value === "") return 0;
  // Converte vírgula para ponto e transforma em float
  const floatValue = parseFloat(value.toString().replace(",", "."));
  return isNaN(floatValue) ? 0 : floatValue;
};
